module.exports = __webpack_public_path__ + "static/media/shape2_6.d6bc01a0.obj";